import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext'; // ⬅️ IMPORTANTE
import 'react-quill/dist/quill.snow.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider> {/* ⬅️ AGREGA ESTE WRAPPER */}
      <App />
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();
